export default {
  keyPM: 1,
  keySC: 2
}
